/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface GetOnboardingInformationResponse
 */
export interface GetOnboardingInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    signedUrlKey: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof GetOnboardingInformationResponse
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingInformationResponse
     */
    lastName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOnboardingInformationResponse
     */
    wallets?: Array<string>;
}

/**
 * Check if a given object implements the GetOnboardingInformationResponse interface.
 */
export function instanceOfGetOnboardingInformationResponse(value: object): value is GetOnboardingInformationResponse {
    if (!('signedUrlKey' in value) || value['signedUrlKey'] === undefined) return false;
    return true;
}

export function GetOnboardingInformationResponseFromJSON(json: any): GetOnboardingInformationResponse {
    return GetOnboardingInformationResponseFromJSONTyped(json, false);
}

export function GetOnboardingInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOnboardingInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'signedUrlKey': json['signedUrlKey'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'wallets': json['wallets'] == null ? undefined : json['wallets'],
    };
}

export function GetOnboardingInformationResponseToJSON(json: any): GetOnboardingInformationResponse {
    return GetOnboardingInformationResponseToJSONTyped(json, false);
}

export function GetOnboardingInformationResponseToJSONTyped(value?: GetOnboardingInformationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signedUrlKey': value['signedUrlKey'],
        'email': value['email'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'wallets': value['wallets'],
    };
}

